import DeploymentSelector from './deployment-selector';

export default DeploymentSelector;
